
// import React, { useState, useEffect } from "react";
// import { useNavigate, Link, useSearchParams } from "react-router-dom";
// import { useAuth } from "hooks/useAuth";
// import SEO from "components/SEO";
// import { trackEvent } from "utils/analytics";

// function getSafeNextPath(next) {
//   if (!next || typeof next !== "string") return "";
//   // Only allow internal redirects.
//   if (!next.startsWith("/") || next.startsWith("//")) return "";
//   return next;
// }

// function getPostLoginPath(searchParams) {
//   const safeNext = getSafeNextPath(searchParams.get("next"));
//   if (safeNext) return safeNext;

//   const selectedPlan = localStorage.getItem("selectedPlan") || localStorage.getItem("pendingPlan");
//   const selectedInterval = localStorage.getItem("selectedInterval") || "monthly";

//   if (selectedPlan === "pro") {
//     return `/pricing?subscribe=pro&interval=${selectedInterval}`;
//   }

//   return "/dashboard";
// }

// const Login = () => {
//   const navigate = useNavigate();
//   const [searchParams] = useSearchParams();
//   const { signIn, session } = useAuth();
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     const userEmail = session?.user?.email;
//     if (userEmail) localStorage.setItem("userEmail", userEmail);
//     if (session) navigate(getPostLoginPath(searchParams), { replace: true });
//   }, [session, navigate, searchParams]);

//   const handleEmailLogin = async (e) => {
//     e.preventDefault();
//     setError("");
//     setLoading(true);

//     const res = await signIn(email, password);
//     setLoading(false);

//     if (!res.success) {
//       setError(res.error?.message || "Login failed");
//       return;
//     }

//     trackEvent("login", {
//       method: "email",
//     });

//     localStorage.setItem("userEmail", email);
//     navigate(getPostLoginPath(searchParams), { replace: true });
//   };

//   return (
//     <>
//       <SEO
//         title="Login - TestimonialsHub"
//         description="Login to your TestimonialsHub account to manage testimonials, video reviews, widgets, embeds, and customer feedback."
//         keywords="testimonial software login, testimonialshub login, customer review dashboard login"
//         path="/login"
//       />
//       <div className="flex min-h-screen bg-gradient-to-br from-purple-400 via-pink-400 to-orange-300 items-center justify-center p-6 font-sans">
//         <div className="w-full max-w-lg bg-gray-100 rounded-2xl shadow-2xl px-10 py-10 flex flex-col justify-center">
//           <h2 className="text-3xl font-bold text-gray-800 mb-3 text-center">
//             Welcome Back
//           </h2>

//           <p className="text-base text-gray-500 mb-8 text-center">
//             Log in to your TestimonialsHub dashboard
//           </p>

//           <p className="text-center text-gray-400 my-2 text-sm">
//             Google login disabled (Supabase removed)
//           </p>

//           <form onSubmit={handleEmailLogin} className="space-y-5 mt-6">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Email
//               </label>
//               <input
//                 type="email"
//                 placeholder="you@example.com"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 required
//                 className="w-full h-12 px-4 border border-gray-300 rounded-xl text-base focus:ring-2 focus:ring-blue-500"
//               />
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Password
//               </label>
//               <input
//                 type="password"
//                 placeholder="******"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 required
//                 className="w-full h-12 px-4 border border-gray-300 rounded-xl text-base focus:ring-2 focus:ring-blue-500"
//               />
//             </div>

//             <div className="flex justify-end">
//               <Link to="/reset" className="text-sm text-blue-600 hover:underline">
//                 Forgot password?
//               </Link>
//             </div>

//             <button
//               type="submit"
//               disabled={loading}
//               className="w-full h-12 mt-4 bg-blue-600 text-white text-base font-semibold rounded-xl hover:bg-blue-700 transition shadow-lg disabled:opacity-60"
//             >
//               {loading ? "Logging in..." : "Log In"}
//             </button>
//           </form>

//           {error && (
//             <p className="text-red-500 text-sm mt-4 text-center">{error}</p>
//           )}

//           <p className="text-sm text-center text-gray-600 mt-6">
//             Don’t have an account?{" "}
//             <Link
//               to={`/signup${searchParams.get("next") ? `?plan=pro` : ""}`}
//               className="text-blue-600 font-medium hover:underline"
//             >
//               Sign up
//             </Link>
//           </p>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Login;


import React, { useState, useEffect } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { useAuth } from "hooks/useAuth";
import SEO from "components/SEO";
import { trackEvent } from "utils/analytics";

function getSafeNextPath(next) {
  if (!next || typeof next !== "string") return "";
  if (!next.startsWith("/") || next.startsWith("//")) return "";
  return next;
}

function getPostLoginPath(searchParams) {
  const safeNext = getSafeNextPath(searchParams.get("next"));
  if (safeNext) return safeNext;

  const selectedPlan =
    localStorage.getItem("selectedPlan") || localStorage.getItem("pendingPlan");
  const selectedInterval = localStorage.getItem("selectedInterval") || "monthly";

  if (selectedPlan === "pro") {
    return `/pricing?subscribe=pro&interval=${selectedInterval}`;
  }

  return "/dashboard";
}

const Login = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { signIn, session } = useAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const userEmail = session?.user?.email;
    if (userEmail) localStorage.setItem("userEmail", userEmail);
    if (session) navigate(getPostLoginPath(searchParams), { replace: true });
  }, [session, navigate, searchParams]);

  const handleEmailLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    const res = await signIn(email, password);
    setLoading(false);

    if (!res.success) {
      setError(res.error?.message || "Login failed");
      return;
    }

    trackEvent("login", {
      method: "email",
    });

    localStorage.setItem("userEmail", email);
    navigate(getPostLoginPath(searchParams), { replace: true });
  };

  return (
    <>
      <SEO
        title="Login - TestimonialsHub"
        description="Login to your TestimonialsHub account to manage testimonials, video reviews, widgets, embeds, and customer feedback."
        keywords="testimonial software login, testimonialshub login, customer review dashboard login"
        path="/login"
      />

      <div className="relative min-h-screen overflow-hidden bg-gradient-to-br from-pink-50 via-white to-orange-50 px-6 py-8 font-sans">
        {/* Background glow effects */}
        <div className="absolute -left-24 -top-24 h-80 w-80 rounded-full bg-pink-300/40 blur-3xl" />
        <div className="absolute right-0 top-20 h-96 w-96 rounded-full bg-purple-300/30 blur-3xl" />
        <div className="absolute bottom-0 right-20 h-96 w-96 rounded-full bg-orange-300/40 blur-3xl" />

        {/* Top brand bar */}
        <div className="relative z-10 mx-auto mb-10 flex max-w-6xl items-center justify-between rounded-full border border-white/70 bg-white/85 px-6 py-4 shadow-xl shadow-pink-200/30 backdrop-blur-md">
          <Link
            to="/"
            className="text-2xl font-extrabold tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-pink-500 via-purple-500 to-orange-500"
          >
            TestimonialsHub
          </Link>

          <div className="hidden items-center gap-8 text-sm font-semibold text-gray-600 md:flex">
            <Link to="/" className="hover:text-pink-500 transition">
              Product
            </Link>
            <Link to="/#features" className="hover:text-pink-500 transition">
              Features
            </Link>
            <Link to="/pricing" className="hover:text-pink-500 transition">
              Pricing
            </Link>
            <Link to="/resources" className="hover:text-pink-500 transition">
              Resources
            </Link>
          </div>

          <Link
            to="/signup"
            className="rounded-full bg-gradient-to-r from-pink-500 to-orange-400 px-5 py-2.5 text-sm font-bold text-white shadow-lg shadow-pink-300/50 transition hover:scale-105"
          >
            Get Started Free
          </Link>
        </div>

        <div className="relative z-10 mx-auto grid min-h-[calc(100vh-140px)] max-w-6xl items-center gap-10 lg:grid-cols-2">
          {/* Left content */}
          <div className="hidden lg:block">
            <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-white bg-white/80 px-4 py-2 text-sm font-semibold text-gray-700 shadow-lg">
              <span className="h-2.5 w-2.5 rounded-full bg-purple-500" />
              Social proof for modern businesses
            </div>

            <h1 className="max-w-xl text-6xl font-black leading-tight tracking-tight text-gray-900">
              Welcome back to your{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-500 via-purple-500 to-orange-500">
                trust dashboard.
              </span>
            </h1>

            <p className="mt-6 max-w-lg text-lg leading-8 text-gray-600">
              Manage testimonials, video reviews, widgets, embeds, and customer
              feedback from one beautiful workspace.
            </p>

            <div className="mt-10 grid max-w-md grid-cols-3 gap-5">
              <div>
                <p className="text-3xl font-black text-gray-900">10k+</p>
                <p className="mt-1 text-sm text-gray-500">Reviews</p>
              </div>
              <div>
                <p className="text-3xl font-black text-gray-900">4.9★</p>
                <p className="mt-1 text-sm text-gray-500">Rating</p>
              </div>
              <div>
                <p className="text-3xl font-black text-gray-900">99%</p>
                <p className="mt-1 text-sm text-gray-500">Happy users</p>
              </div>
            </div>
          </div>

          {/* Login card */}
          <div className="mx-auto w-full max-w-lg">
            <div className="relative rounded-[2rem] border border-white/80 bg-white/90 p-3 shadow-2xl shadow-pink-200/50 backdrop-blur-xl">
              <div className="absolute -right-5 -top-5 hidden rounded-2xl bg-gradient-to-br from-pink-500 via-purple-500 to-orange-400 p-4 text-white shadow-xl md:block">
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M21 15a4 4 0 0 1-4 4H7l-4 4V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z" />
                </svg>
              </div>

              <div className="rounded-[1.5rem] bg-gradient-to-br from-white via-pink-50/70 to-orange-50/80 px-8 py-10 sm:px-10">
                <div className="mb-8 text-center">
                  <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-pink-500 via-purple-500 to-orange-400 text-white shadow-lg shadow-pink-300/50">
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                      <circle cx="12" cy="7" r="4" />
                    </svg>
                  </div>

                  <h2 className="text-4xl font-black tracking-tight text-gray-900">
                    Welcome Back
                  </h2>

                  <p className="mt-3 text-base text-gray-500">
                    Log in to your TestimonialsHub dashboard
                  </p>
                </div>

                <form onSubmit={handleEmailLogin} className="space-y-5">
                  <div>
                    <label className="mb-2 block text-sm font-bold text-gray-700">
                      Email Address
                    </label>

                    <div className="relative">
                      <span className="absolute left-4 top-1/2 -translate-y-1/2 text-pink-500">
                        ✉
                      </span>

                      <input
                        type="email"
                        placeholder="you@example.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        className="h-13 w-full rounded-2xl border border-pink-100 bg-white px-12 py-4 text-base text-gray-800 shadow-sm outline-none transition placeholder:text-gray-400 focus:border-pink-400 focus:ring-4 focus:ring-pink-200/60"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="mb-2 block text-sm font-bold text-gray-700">
                      Password
                    </label>

                    <div className="relative">
                      <span className="absolute left-4 top-1/2 -translate-y-1/2 text-orange-500">
                        🔒
                      </span>

                      <input
                        type="password"
                        placeholder="Enter your password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        className="h-13 w-full rounded-2xl border border-orange-100 bg-white px-12 py-4 text-base text-gray-800 shadow-sm outline-none transition placeholder:text-gray-400 focus:border-orange-400 focus:ring-4 focus:ring-orange-200/60"
                      />
                    </div>
                  </div>

                  <div className="flex items-center justify-between">
                    {/* <p className="text-xs font-medium text-gray-400">
                      Google login disabled
                    </p> */}

                    <Link
                      to="/reset"
                      className="text-sm font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-orange-500 hover:opacity-80"
                    >
                      Forgot password?
                    </Link>
                  </div>

                  <button
                    type="submit"
                    disabled={loading}
                    className="group relative h-14 w-full overflow-hidden rounded-2xl bg-gradient-to-r from-pink-500 via-purple-500 to-orange-400 text-base font-extrabold text-white shadow-xl shadow-pink-300/50 transition hover:scale-[1.02] disabled:cursor-not-allowed disabled:opacity-60"
                  >
                    <span className="relative z-10">
                      {loading ? "Logging in..." : "Log In"}
                    </span>
                    <span className="absolute inset-0 bg-gradient-to-r from-orange-400 via-pink-500 to-purple-500 opacity-0 transition group-hover:opacity-100" />
                  </button>
                </form>

                {error && (
                  <div className="mt-5 rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-center text-sm font-medium text-red-600">
                    {error}
                  </div>
                )}

                <p className="mt-7 text-center text-sm text-gray-600">
                  Don’t have an account?{" "}
                  <Link
                    to={`/signup${searchParams.get("next") ? `?plan=pro` : ""}`}
                    className="font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-orange-500 hover:opacity-80"
                  >
                    Sign up
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;